<template>
  <!-- common categories -->
  <div
    v-mask="{ open }"
    class="glaxi-menu__categories__container">

    <div class="glaxi-menu__categories">
      <div class="glaxi-menu__categories__back-mobile" @click="toggleCategories()">{{ $t('labelMenu.back') }}</div>
      <!-- tabs area -->
      <div class="glaxi-menu__categories__tabs glaxi-menu__categories__tabs--menu_tabs">
        <ul>
          <li
            @click="$_activeTab('all')"
            :class="{'glaxi-menu__categories__tabs__li--active': activeTab === 'all'}">
              {{ $t('labelMenu.tab01') }}
          </li>
          <li
            @click="$_activeTab('news')"
            :class="{'glaxi-menu__categories__tabs__li--active': activeTab === 'news'}">
              {{ $t('labelMenu.tab02') }}
          </li>
          <li
            @click="$_activeTab('special')"
            :class="{'glaxi-menu__categories__tabs__li--active': activeTab === 'special'}">
              {{ $t('labelMenu.tab03') }}
          </li>
        </ul>
      </div>

      <!-- ALL tab -->
      <div
        v-show="activeTab === 'all'"
        class="glaxi-menu__categories__section glaxi-menu__categories__section--all">
        
        <div class="glaxi-menu__categories__contents">
          <ul class="glaxi-menu__categories__all">
            <li
              v-for="(category, index) of categories"
              :key="index"
              :class="{'glaxi-menu__categories__all--bigElement' : category.sys.id === 'I7cOqncPSewE8M2k8IC48' || category.sys.id === '6b1WENWaVUiwCUokWCiKsm'}">
              <router-link :to="{ name: `${lang}.single-category`, params: { slug: category.fields.slug } }">
                <img
                  v-if="typeof category.fields.image !== 'undefined'"
                  :src="category.fields.image.fields.file.url"
                  :alt="category.fields.image.fields.description"
                  :width="category.fields.image.fields.file.details.image.width"
                  :height="category.fields.image.fields.file.details.image.height">
                <div>
                  <p>{{ category.fields.title }} <sup v-html="$_getProductsCount(category.fields.slug)" /></p>
                </div>
              </router-link>
            </li>
          </ul>
        </div>

        <div
          v-if="!loading"
          class="glaxi-menu__categories__tags">
          <ul
            v-for="(tagsParent, index) of orderedTagsParents"
            :key="index">
            <li>{{ tagsParent.fields.title }}</li>
            <li
              v-for="(tag, index) of $_filterEntriesByTagParentTitle(tagsParent.fields.title)"
              :key="index">
              <router-link 
                :class="'underline_link'" 
                :to="{ name: `${lang}.single-tag`, params: { slug: tag.fields.slug } }">
                {{ tag.fields.title }}
              </router-link>
            </li>
          </ul>
        </div>

      </div>

      <!-- NEWS tab -->
      <div
        v-show="activeTab === 'news' && typeof newsList !== 'undefined'"
        class="glaxi-menu__categories__section glaxi-menu__search__content">
        <ProductsFromList :list="newsList" />
      </div>

      <!-- SPECIAL tab -->
      <div
        v-show="typeof specialList !== 'undefined' && activeTab === 'special'"
        class="glaxi-menu__categories__section glaxi-menu__search__content">
        <ProductsFromList :list="specialList" />
      </div>

    </div>
  </div>

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { TweenLite } from 'gsap/TweenLite'
import { TweenMax } from 'gsap/TweenMax'

import ProductsFromList from '@/components/ProductsFromList/ProductsFromList.vue'

export default {
  name: 'MenuCategories',
  components: {
    ProductsFromList
  },
  data: () => ({
    loading: true,
    activeTab: 'all' // news, special
  }),
  props: {
    open: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    ...mapGetters('contentful', [
      'categories',
      'tagsParents',
      'tags',
      'products',
      'tag'
    ]),
    ...mapGetters([
      'lang'
    ]),
    orderedTagsParents: {
      get () {
        if (this.loading) return []
        return this.tagsParents.sort((a, b) => {
          if (a.fields.order < b.fields.order) return -1
          if (a.fields.order > b.fields.order) return 1
          return 0
        })
      }
    },
    newsList: {
      get () {
        if (this.loading) return []
        return this.$_filterEntriesByTagId('13RpBAab2koSygiyMGUEUE')
      }
    },
    specialList: {
      get () {
        if (this.loading) return []
        return this.$_filterEntriesByTagId('4Uk2NflK3C4oaes6I86mWy')
      } 
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    ...mapActions('contentful', [
      'loadCategories',
      'loadTagsParents',
      'loadTags',
      'loadProducts'
    ]),
    toggleCategories () {
      this.$emit('toggle-categories')
      // this.open = !this.open
    },
    $_getProductsCount (currentSlug) {
      return this.products.filter((product) => (typeof product.fields.category !== 'undefined' && typeof product.fields.category.fields.slug !== 'undefined' && product.fields.category.fields.slug === currentSlug)).length
    },
    $_filterEntriesByTagId (tagId) {
      return this.products
        .filter(productElement => typeof productElement.fields.tags !== 'undefined')
        .reduce((accumulator, productElement) => {
          if (productElement.fields.tags === undefined) return accumulator
          productElement.fields.tags.forEach(tag => {
            if (typeof tag.sys.id !== 'undefined' && tag.sys.id === tagId) return accumulator.push(productElement)
          })
          return accumulator
        }, [])
    },
    $_activeTab (state) {
      this.activeTab = state
    },
    $_filterEntriesByTagParentTitle (tagTitle) {
      return this.tags
        .filter(t => typeof t.fields.parentGroup !== 'undefined')
        .filter(t => tagTitle === t.fields.parentGroup.fields.title)
    },
    async loadData () {
      this.loading = true
      try {
        await Promise.all([this.loadCategories(), this.loadTagsParents(), this.loadTags(), this.loadProducts()])
        this.loading = false
      } catch (e) {
        // TODO sentry
      }
    }
  },
  directives: {
    'mask': {
      inserted (el, binding) {
        TweenLite.to(el, 0, {width:'0%'})
      },
      componentUpdated (el, binding) {
        const { open } = binding.value
        if (open) {
          TweenLite.to(el, .8, {ease: Power2.easeOut, width:'100%', onComplete: () => document.body.classList.add('--overflow-hidden')})
        }
        else{
          document.body.classList.remove('--overflow-hidden')
          TweenLite.to(el, .8, {ease: Power2.easeOut, width:'0%'})
        }
      }
    }
  }
}
</script>

<style lang="scss">
  @import "./categories.scss";
  @import "./maskEffect.scss";
</style>
